import type { Release } from "@typings/entities/releases";
import { STATUS_OPTIONS } from "@typings/entities/releases/filter";
import { formatDate } from "@utils/formatters";
import { RELEASE_OCCURRENCE_TYPES } from "@typings/entities/occurrence/occurrence";
import type { ReleasesGeoJsonResponse } from "@services/releases/getGeoJson/type";
import { MARKER_CONFIG } from "@typings/entities/releases/enums";

export function getStatusLabel(status: string) {
  const statusOption = STATUS_OPTIONS.find((option) => option.value === status);
  return statusOption ? statusOption.label : status;
}

export function getReleaseTypeLabel(type: string) {
  const typeOption = RELEASE_OCCURRENCE_TYPES.find(
    (option) => option.value === type,
  );
  return typeOption ? typeOption.label : type;
}

export function prepareReleasesTable(releases: Release[]): Release[] {
  return releases.map((release) => ({
    ...release,
    ufuName: release.individual.ufuName,
    species: release.individual?.taxonomicGroup?.species,
    executorName: release.executor.username,
    expectedDate: formatDate(release.expectedDate || null),
    executionDate: formatDate(release.executionDate || null),
  }));
}

export function prepareViewRelease(release?: Release): Release | undefined {
  if (!release) return undefined;

  return {
    ...release,
    expectedDate: formatDate(release.expectedDate) || "",
    executionDate: formatDate(release.executionDate) || "",
    occurrence: release.occurrence
      ? {
          ...release.occurrence,
          type: getReleaseTypeLabel(release.occurrence.type || ""),
        }
      : null,
  };
}

export function mapColorToReleases(
  geoJson: ReleasesGeoJsonResponse,
): ReleasesGeoJsonResponse {
  return {
    ...geoJson,
    features: geoJson.features.map((feature) => {
      const status = feature.properties
        .status as keyof typeof MARKER_CONFIG.colorMapping;
      return {
        ...feature,
        properties: {
          ...feature.properties,
          color:
            MARKER_CONFIG.colorMapping[status] ??
            MARKER_CONFIG.colorMapping.undefined,
        },
      };
    }),
  };
}
